import React from 'react';
import '../Styles/CustomPopup.css'; // Ensure styles are properly added
import { useNavigate } from 'react-router-dom';

const CustomPopup = ({ message, subMessage }) => {
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate('/home'); // Redirect to the home page
  };

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <div className="popup-icon">
          <span>✔</span>
        </div>
        <h3 className="popup-title">{message}</h3>
        <p className="popup-subtitle">{subMessage}</p>
        <button className="popup-button" onClick={handleRedirect}>
          Explore More Personas
        </button>
      </div>
    </div>
  );
};

export default CustomPopup;
